import { SharedContent } from './shared-content';

export const PersonalInfoContent = {
  pageTitle: `Begin opening your new account by verifying your personal information`,
  pageDescription: `Let's start by reviewing some personal info.`,
  accordions: [
    {
      title: `Why do I need to open a new account?`,
      text: `To transfer an account from someone who has passed away, you need to re-register that account into your name. To do that, we need to open a brand-new account for you, and then transfer the investments into that brand-new account. Think of it like transferring the ownership of a car that you bought from a friend or relative: you need to re-register it in your name before you can call it your own.`,
    },
  ],
  continueButton: `Continue`,
  progressLabelIT: 'Internal transfer progress',
  progressLabelITOpenAccount: SharedContent.progressLabelITOpenAccount,
  accountHatPrefix: SharedContent.accountHatPrefix,
  modal: {
    default: {
      title: 'Updating your personal information',
      updateInfoPreTag: `You'll need to update your personal information before continuing. <br>Update your name, email, and birth date by going to your `,
      updateInfoPostTag: ` and selecting the personal info tab. For changes to your social security number or citizenship, please call us at <strong>800-337-8476</strong>, M-F 8 a.m. to 8 p.m., Eastern time.`,
    },
    hasMissingInfo: {
      title: `It seems we are missing some information`,
      updateInfoPreTag: `You'll need to update the missing field(s) before continuing. <br>Update your name, email, and birth date by going to your `,
      updateInfoPostTag: ` and selecting the personal info tab. For changes to your social security number or citizenship, please call us at <strong>800-337-8476</strong>, M-F 8 a.m. to 8 p.m., Eastern time.`,
    },
    nextSteps: `Once you've updated your personal information, restart this process to complete your request.`,
    accountMaintenance: `profile & account settings`,
    accountMaintenanceLink: {
      satLink: `https://satpersonal1.vanguard.com/usa/mnt-profile-and-account-settings/paas/personal-info`,
      prodLink: `https://personal1.vanguard.com/usa/mnt-profile-and-account-settings/paas/personal-info`,
    },
  },
};
